import { useContext, useEffect, useRef, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import { GoLocation } from "react-icons/go";
import styled from "styled-components";
import limitStringLength from "../../controllers/utils/limitStringLength";
import Context from "../../Context";
import mapSettingsOne from "../../data/map/mapSettingsOne";

let apiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY;

const Map = styled.div`
  width: 100%;
  height: 100%;
`;

let stylesForShowingPlaces = [
  {
    featureType: "all",
    elementType: "geometry.fill",
    stylers: [{ weight: "2.00" }],
  },
  {
    featureType: "all",
    elementType: "geometry.stroke",
    stylers: [{ color: "#9c9c9c" }],
  },
  {
    featureType: "all",
    elementType: "labels.text",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "landscape",
    elementType: "all",
    stylers: [{ color: "#f2f2f2" }],
  },
  {
    featureType: "landscape",
    elementType: "geometry.fill",
    stylers: [{ color: "#ffffff" }],
  },
  {
    featureType: "landscape.man_made",
    elementType: "geometry.fill",
    stylers: [{ color: "#ffffff" }],
  },
  {
    featureType: "poi",
    elementType: "all",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#333333" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#ffffff" }],
  },
  {
    featureType: "poi.business",
    elementType: "all",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "poi.establishment",
    elementType: "all",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "poi.place_of_worship",
    elementType: "all",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "poi.school",
    elementType: "all",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "road",
    elementType: "all",
    stylers: [{ saturation: -100 }, { lightness: 45 }],
  },
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [{ color: "#eeeeee" }],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#7b7b7b" }],
  },
  {
    featureType: "road",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#ffffff" }],
  },
  {
    featureType: "road.highway",
    elementType: "all",
    stylers: [{ visibility: "simplified" }],
  },
  {
    featureType: "road.arterial",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "transit",
    elementType: "all",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [{ color: "#46bcec" }, { visibility: "on" }],
  },
  {
    featureType: "water",
    elementType: "geometry.fill",
    stylers: [{ color: "#c8d7d4" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#070707" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#ffffff" }],
  },
];

function MapWithMultipleMarkers({ markers, zoom = 14, versionForUpdating }) {
  const { themeState, colorMode } = useContext(Context);
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {}, [isLoading]);

  useEffect(() => {
    if (!apiKey) {
      setError("Google Maps API key is required");
      setIsLoading(false);
      return;
    }

    const initMap = async () => {
      try {
        const loader = new Loader({
          apiKey,
          version: "weekly",
          libraries: ["places"],
        });

        await loader.load();

        setupMap();

        function setupMap() {
          if (mapRef.current) {
            // Initialize map
            mapInstance.current = new window.google.maps.Map(mapRef.current, {
              center: markers[0],
              zoom,
              styles: mapSettingsOne,
              disableDefaultUI: false,
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: true,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
            });

            // Create draggable marker

            console.log("markers", markers);

            function calculateBoxLength(characterLength) {
              if (characterLength <= 4) {
                return characterLength * 20;
              } else if (characterLength <= 7) {
                return characterLength * 18;
              } else {
                return characterLength * 14;
              }
            }

            for (let item of markers) {
              let theText = limitStringLength(item.text, 10);

              //I removed filter and shadow from svg and it improved the performance
              const svgIcon = `
            <svg width="200" height="40" xmlns="http://www.w3.org/2000/svg">
              <defs>
             
              </defs>
              <rect x="0" y="5.5" width="${calculateBoxLength(theText.length)}" height="30" rx="15" fill="${themeState.elementAlt}" stroke="${themeState.element}" stroke-width="1"/>
              <circle cx="16" cy="20" r="8" fill="${themeState.mapAccent}" stroke="${themeState.element}" stroke-width="2"/>
              <text x="30" y="25" font-family="Arial, sans-serif" font-size="14" font-weight="bold" fill="${themeState.element}">${theText}</text>
            </svg>
          `;

              new window.google.maps.Marker({
                position: item,
                map: mapInstance.current,
                draggable: false,
                title: `${item.text}`,
                animation: window.google.maps.Animation.DROP,
                // label: {
                //   text: `${item.text}`,
                //   fontSize: "15px",
                //   fontWeight: "bold",
                //   color: "#111111",
                //   background: "#111",
                // },
                icon: {
                  // path: window.google.maps.SymbolPath.CIRCLE,
                  url:
                    "data:image/svg+xml;charset=UTF-8," +
                    encodeURIComponent(svgIcon),
                  scale: 25,
                  fillColor: "#111111",
                  fillOpacity: 1,
                  strokeWeight: 3,
                  strokeColor: "#ffffff",
                  // labelOrigin: new window.google.maps.Point(0, 2),
                },
              });
            }

            setIsLoading(false);
          }
        }
      } catch (err) {
        console.error("Error loading Google Maps:", err);
        setError("Failed to load Google Maps");
        setIsLoading(false);
      }
    };

    initMap();

    return () => {
      if (markerRef.current) {
        markerRef.current.setMap(null);
      }
    };
  }, [colorMode, versionForUpdating]);

  if (error || !apiKey) {
    console.error(error);
    return null;
  }

  return <Map ref={mapRef} />;
}

export default MapWithMultipleMarkers;
